module.exports = __webpack_public_path__ + "static/media/ftu-build-program.1f80adf0.png";